import { HOT_LIST } from '@/pages/home/data';

const tagTone: Record<string, string> = {
  '爆': 'bg-primary-500 text-background-50',
  '热': 'bg-secondary-500 text-background-50',
  '新': 'bg-accent-500 text-foreground-950',
};

export default function HotBoard() {
  return (
    <section id="hot" className="mx-auto w-full max-w-7xl scroll-mt-24 px-4 py-16 md:px-6 md:py-24">
      {/* header */}
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="flex items-center gap-2 text-xs font-semibold tracking-[0.24em] text-primary-600">
            <span className="inline-block h-px w-8 bg-primary-500" />
            01 · 实时热搜
          </div>
          <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            今日塌房·热搜榜单
          </h2>
          <p className="mt-2 max-w-md text-sm text-foreground-600">
            每一条都标好热度与阶段，点标题进详情、吃透全程，不做标题党。
          </p>
        </div>
        <a
          href="#roster"
          className="inline-flex h-10 w-fit items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
        >
          名单对应查看
          <i className="ri-arrow-right-line" />
        </a>
      </div>

      {/* list */}
      <div className="mt-10 divide-y divide-background-200/80 border-t border-background-200/80">
        {HOT_LIST.map((item) => {
          const isTop3 = Number(item.rank) <= 3;
          return (
            <a
              href="#bundle"
              key={item.rank}
              className="group grid grid-cols-[auto_1fr] items-start gap-x-4 gap-y-2 py-6 transition-colors hover:bg-background-100/40 sm:grid-cols-[3.5rem_auto_1fr_auto] sm:items-center sm:gap-x-6 sm:px-3"
            >
              {/* rank */}
              <span
                className={`font-heading text-2xl font-black leading-none md:text-3xl ${
                  isTop3 ? 'text-primary-500' : 'text-foreground-300'
                }`}
              >
                {item.rank}
              </span>

              {/* mobile meta fallback hidden on desktop handled below */}
              <div className="min-w-0 sm:hidden">
                <div className="flex flex-wrap items-center gap-2">
                  <span
                    className={`inline-flex h-5 items-center rounded-sm px-1.5 text-[11px] font-bold ${tagTone[item.tag]}`}
                  >
                    {item.tag}
                  </span>
                  <span className="text-[11px] text-foreground-500">{item.heat}</span>
                </div>
                <h3 className="mt-1.5 text-base font-semibold text-foreground-950 group-hover:text-primary-700">
                  {item.title}
                </h3>
              </div>

              {/* desktop title column */}
              <div className="hidden min-w-0 sm:block">
                <h3 className="flex flex-wrap items-center gap-3 text-lg font-semibold leading-snug text-foreground-950 group-hover:text-primary-700">
                  <span className="whitespace-nowrap">{item.title}</span>
                  <span
                    className={`inline-flex h-5 items-center rounded-sm px-1.5 text-[11px] font-bold ${tagTone[item.tag]}`}
                  >
                    {item.tag}
                  </span>
                </h3>
              </div>

              {/* summary + heat */}
              <p className="col-start-2 text-sm leading-relaxed text-foreground-600 sm:col-start-3 sm:line-clamp-1">
                {item.summary}
              </p>

              <span className="col-start-2 hidden items-center gap-1 text-sm text-foreground-500 sm:col-start-4 sm:flex">
                <i className="ri-fire-line text-primary-500" />
                {item.heat}
              </span>
            </a>
          );
        })}
      </div>
    </section>
  );
}